import * as apiFactory from "./ApiFactory";
import { Api } from "./Api";
import type { RetentionStatus } from "./RetentionService";

export interface FullRetentionBrandConfig extends UnityViewer.Retention.BrandConfig {
  retentionFilters?: Array<{ key: RetentionStatus["key"]; value: string }>;
}

export async function GetRetentionConfig(clientName: string, brand: string) {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<FullRetentionBrandConfig>(`api/brandconfiguration/retention/${clientName}/${brand}`);
}
